import { observer } from 'mobx-react';
import * as React from 'react';
import { external, inject } from 'tsdi';

import { Checkbox } from '../components/checkbox';
import { featureEnabled } from '../core/common/feature';
import { I18n } from '../core/i18n';
import {
    CheckboxField,
    CheckboxFieldInner,
    CheckboxLabel,
    ColumnShort,
    EmailIcon
} from './styles';

export interface ChannelCheckboxProps {
    label: string;
    isChecked: boolean;
    isDisabled?: boolean;
    onClick(): void;
    'data-role'?: string;
    hasPendingDoi?: boolean;
}

@external
@observer
export class ChannelCheckbox extends React.Component<ChannelCheckboxProps> {
    @inject
    private i18n!: I18n;

    public render(): React.JSX.Element {
        const { translate } = this.i18n;
        const {
            label,
            isChecked,
            isDisabled,
            hasPendingDoi,
            'data-role': dataRole,
            onClick
        } = this.props;

        return (
            <ColumnShort>
                <CheckboxField>
                    <CheckboxFieldInner>
                        <CheckboxLabel htmlFor={dataRole}>
                            {translate(label)}
                        </CheckboxLabel>
                        <Checkbox
                            checked={isChecked}
                            disabled={isDisabled}
                            onClick={onClick}
                            data-role={dataRole}
                        />
                    </CheckboxFieldInner>
                </CheckboxField>
                {featureEnabled('DOUBLE_OPT_IN') && hasPendingDoi && (
                    <EmailIcon />
                )}
            </ColumnShort>
        );
    }
}
